import React from "react";

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  const pageLimit = 10; // Number of page numbers to show at a time

  // Handle previous button
  const handlePrev = () => {
    if (currentPage > 1) onPageChange(currentPage - 1);
  };

  // Handle next button
  const handleNext = () => {
    if (currentPage < totalPages) onPageChange(currentPage + 1);
  };

  // Calculate the range of page numbers to display
  const startPage = Math.floor((currentPage - 1) / pageLimit) * pageLimit + 1;
  const endPage = Math.min(startPage + pageLimit - 1, totalPages);

  // Render page numbers
  const renderPageNumbers = () => {
    let pageNumbers = [];
    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(i);
    }
    return pageNumbers.map((page) => (
      <button
        key={page}
        className={`btn ${currentPage === page ? "btn-primary" : "btn-dark"}`}
        style={{ borderRight: "1px solid yellow" }}
        onClick={() => onPageChange(page)}
      >
        {page}
      </button>
    ));
  };

  return (
    <div className="pagination">
      {/* Prev Button */}
      <button
        className="btn btn-dark"
        style={{ borderRight: "1px solid yellow" }}
        disabled={currentPage === 1}
        onClick={handlePrev}
      >
        <i className="fa fa-angle-left mr-2"></i> Prev
      </button>

      {/* Page Numbers */}
      {renderPageNumbers()}

      {/* Next Button */}
      <button
        className="btn btn-dark"
        style={{ borderRight: "1px solid yellow" }}
        disabled={currentPage === totalPages}
        onClick={handleNext}
      >
        Next <i className="fa fa-angle-right ml-2"></i>
      </button>
    </div>
  );
};

export default Pagination;